import { $selectedPackages } from "../../store/selected/selectedPackages";
import { $selectedSupplements } from "../../store/selected/selectedSupplements";
import { isPresent } from "../../utils";
import i18n from "../../shared/i18n";

export const validateMenuStep = async (showErrors = true): Promise<boolean> => {
  const selectedPackages = $selectedPackages.getState();

  const packageSupplementsNotServed = selectedPackages.some(
    ({ supplementsServing }) => {
      return supplementsServing.some((i) => {
        return i.servingActivityId === null;
      });
    }
  );

  if (packageSupplementsNotServed) {
    if (showErrors) {
      alert(i18n.t("step_Menu:invalidStepMessages.packageSupplements"));
    }
    return false;
  }

  const selectedSupplements = $selectedSupplements.getState();

  const supplementsNotServed = selectedSupplements.some(
    ({ serving: { activityId } }) => !isPresent(activityId)
  );

  if (supplementsNotServed) {
    if (showErrors) alert(i18n.t("step_Menu:invalidStepMessages.supplements"));
    return false;
  }

  return true;
};
